"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  ImagePicker: () => ImagePicker
});
module.exports = __toCommonJS(index_native_exports);
var import_react_native_nitro_modules = require("react-native-nitro-modules");
var import_nativeError = require("../nativeError");
var import_options = require("./options");
var hybrid;
function native(verb) {
  if (hybrid === void 0) {
    hybrid = import_react_native_nitro_modules.NitroModules.hasHybridObject("OneImagePicker") ? import_react_native_nitro_modules.NitroModules.createHybridObject("OneImagePicker") : null;
  }
  if (!hybrid) {
    throw new Error(`ImagePicker.${verb} needs a native build`);
  }
  return hybrid;
}
function toResult(result) {
  if (result.canceled) return {
    canceled: true,
    assets: null
  };
  if (!result.assets) {
    throw new Error("ImagePicker: native returned a pick without assets");
  }
  return {
    canceled: false,
    assets: result.assets
  };
}
function launchLibrary() {
  var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var resolved = (0, import_options.resolveImagePickerOptions)(options);
  return native("launchLibrary").launchLibrary(resolved).then(toResult, import_nativeError.rethrowNativeError);
}
function launchCamera() {
  var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var resolved = (0, import_options.resolveCameraOptions)(options);
  return native("launchCamera").launchCamera(resolved).then(toResult, import_nativeError.rethrowNativeError);
}
async function getCameraPermissions() {
  return native("getCameraPermissions").getCameraPermissions();
}
async function requestCameraPermissions() {
  return native("requestCameraPermissions").requestCameraPermissions().catch(import_nativeError.rethrowNativeError);
}
var ImagePicker = Object.freeze({
  launchLibrary,
  launchCamera,
  getCameraPermissions,
  requestCameraPermissions
});
//# sourceMappingURL=index.native.js.map
